import { useParams } from 'next/navigation';

import { useAccountContext } from '~context/account';
import { usePaywallContext } from '~context/paywall';
import { CheckoutReason } from '~features/annals';

import SaveOnPro from '../../../../public/assets/saveOnPro.svg';
import { PremiumContainer, PremiumDiv, PremiumText } from './Premium.styles';

export const Premium = ({ visible }: { visible: boolean }) => {
	const { hasSubscription } = useAccountContext();
	const { openPaywall } = usePaywallContext();
	const { recipientId: botClientId } = useParams<{ recipientId?: string }>();
	return (
		<PremiumContainer visible={visible}>
			{hasSubscription ? (
				<PremiumText size="small">Premium</PremiumText>
			) : (
				<PremiumDiv
					onClick={openPaywall({
						checkoutReason: botClientId
							? CheckoutReason.Chat
							: CheckoutReason.ChatList,
						prefer: 'subscription',
						botClientId,
					})}
				>
					<SaveOnPro />
				</PremiumDiv>
			)}
		</PremiumContainer>
	);
};
